import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, Col, Flex, notification, Popconfirm, Row, Table } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/pro-regular-svg-icons";
import dayjs from "dayjs";

import { GET, POST } from "../../../../providers/useAxiosQuery";
import { system_id } from "../../../../providers/companyInfo";
import { PageFacultyLoadContext } from "../PageFacultyLoad";
import {
	TableGlobalSearchAnimated,
	TablePageSize,
	TablePagination,
	TableShowingEntriesV2,
	useTableScrollOnTop,
} from "../../../../providers/CustomTableFilter";
import notificationErrors from "../../../../providers/notificationErrors";
import FloatSelect from "../../../../providers/FloatSelect";
import ModalFormFacultyLoad from "./ModalFormFacultyLoad";

export default function PageFacultyLoadContent(props) {
	const { isTrash } = props;
	const {
		moduleCode,
		dataFaculty,
		dataDepartments,
		dataRooms,
		dataSchoolYear,
		dataSemester,
		setProfileIds,
	} = useContext(PageFacultyLoadContext);
	const location = useLocation();

	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [toggleModalFormFacultyLoad, setToggleModalFormFacultyLoad] = useState({
		open: false,
		data: null,
	});
	const [tableFilter, setTableFilter] = useState({
		page: 1,
		page_size: 50,
		search: "",
		sort_field: "fullname",
		sort_order: "asc",
		calendar_view: 0,
		from: "page_faculty_monitoring_list",
		profile_ids: [],
		department_ids: [],
		school_year_ids: [],
		semester_ids: [],
		date_now: dayjs().format("YYYY-MM-DD"),
		module_code: moduleCode,
		system_id: system_id,
		isTrash: isTrash,
	});

	useEffect(() => {
		setTableFilter((ps) => ({
			...ps,
			isTrash,
		}));

		return () => {};
	}, [isTrash]);

	const { data: dataSource, refetch: refetchSource } = GET(
		`api/faculty_load?${new URLSearchParams(tableFilter)}`,
		"faculty_load",
	);

	useEffect(() => {
		refetchSource();
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tableFilter]);

	const onChangeTable = (pagination, filters, sorter) => {
		setTableFilter((prevState) => ({
			...prevState,
			sort_field: sorter.columnKey,
			sort_order: sorter.order ? sorter.order.replace("end", "") : null,
			page: 1,
		}));
	};

	const {
		mutate: mutateDeleteFacultyLoad,
		isLoading: isLoadingDeleteFacultyLoad,
	} = POST(`api/faculty_load_multiple_archived`, "faculty_load_list");

	const handleSelectedArchived = (isTrash) => {
		let data = {
			isTrash,
			ids: selectedRowKeys,
		};
		mutateDeleteFacultyLoad(data, {
			onSuccess: (res) => {
				if (res.success) {
					notification.success({
						message: "Faculty Monitoring",
						description: res.message,
					});
					setSelectedRowKeys([]);
				} else {
					notification.error({
						message: "Faculty Monitoring",
						description: res.message,
					});
				}
			},
			onError: (err) => {
				notificationErrors(err);
			},
		});
	};

	useTableScrollOnTop("tblFacultyLoadList", location.pathname);

	return (
		<Row gutter={[20, 20]}>
			<Col xs={24} sm={24} md={12} lg={8} xl={6}>
				<FloatSelect
					label="Faculty"
					value={tableFilter.profile_ids}
					multi="multiple"
					allowClear
					onChange={(value) => {
						setTableFilter((ps) => ({ ...ps, profile_ids: value }));
						setProfileIds(value || []);
					}}
					options={
						dataFaculty && dataFaculty.data
							? dataFaculty.data.map((item) => ({
									value: item.id,
									label: item.fullname,
								}))
							: []
					}
				/>
			</Col>
			<Col xs={24} sm={24} md={12} lg={8} xl={6}>
				<FloatSelect
					label="Department"
					value={tableFilter.department_ids}
					multi="multiple"
					onChange={(value) =>
						setTableFilter((ps) => ({ ...ps, department_ids: value }))
					}
					allowClear
					options={
						dataDepartments && dataDepartments.data
							? dataDepartments.data.map((item) => ({
									value: item.id,
									label: item.department_name,
								}))
							: []
					}
				/>
			</Col>
			<Col xs={24} sm={24} md={12} lg={8} xl={6}>
				<FloatSelect
					label="School Year"
					value={tableFilter.school_year_ids}
					multi="multiple"
					allowClear
					onChange={(value) => {
						setTableFilter((ps) => ({ ...ps, school_year_ids: value }));
					}}
					options={
						dataSchoolYear && dataSchoolYear.data
							? dataSchoolYear.data.map((item) => ({
									value: item.id,
									label: `${item.sy_from}-${item.sy_to}`,
								}))
							: []
					}
				/>
			</Col>
			<Col xs={24} sm={24} md={12} lg={8} xl={6}>
				<FloatSelect
					label="Semester"
					value={tableFilter.semester_ids}
					multi="multiple"
					allowClear
					onChange={(value) => {
						setTableFilter((ps) => ({ ...ps, semester_ids: value }));
					}}
					options={
						dataSemester && dataSemester.data
							? dataSemester.data.map((item) => ({
									value: item.id,
									label: item.semester,
								}))
							: []
					}
				/>
			</Col>
			<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
				<Flex justify="space-between" align="center" className="tbl-top-filter">
					<Flex gap={15}>
						<Button
							className={`btn-main-primary min-w-150 ${
								tableFilter.isTrash === 0 ? "active" : "outlined"
							}`}
							onClick={() => {
								setTableFilter((ps) => ({
									...ps,
									isTrash: 0,
								}));
								setSelectedRowKeys([]);
							}}
						>
							Active
						</Button>

						<Button
							className={`btn-main-primary min-w-150 ${
								tableFilter.isTrash === 1 ? "active" : "outlined"
							}`}
							onClick={() => {
								setTableFilter((ps) => ({
									...ps,
									isTrash: 1,
								}));
								setSelectedRowKeys([]);
							}}
						>
							Archived
						</Button>
					</Flex>

					<Flex gap={15}>
						<TablePageSize
							tableFilter={tableFilter}
							setTableFilter={setTableFilter}
						/>
					</Flex>
				</Flex>
			</Col>

			<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
				<Flex justify="space-between" align="center" className="tbl-top-filter">
					<TableGlobalSearchAnimated
						tableFilter={tableFilter}
						setTableFilter={setTableFilter}
					/>

					<Flex gap={15}>
						<TableShowingEntriesV2 />

						<TablePagination
							tableFilter={tableFilter}
							setTableFilter={setTableFilter}
							total={dataSource?.data.total}
							showLessItems={true}
							showSizeChanger={false}
							tblIdWrapper="tbl_wrapper"
						/>
					</Flex>
				</Flex>
			</Col>

			{selectedRowKeys.length > 0 && (
				<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
					<Popconfirm
						title={
							<>
								Are you sure you want to
								<br />
								{tableFilter.isTrash === 0 ? "archive" : "active"} the selected{" "}
								{selectedRowKeys.length > 1 ? "faculty loads" : "faculty load"}?
							</>
						}
						okText="Yes"
						cancelText="No"
						onConfirm={() => {
							handleSelectedArchived(tableFilter.isTrash);
						}}
					>
						<Button
							className="btn-main-secondary"
							name="btn_active_archive"
							loading={isLoadingDeleteFacultyLoad}
						>
							{tableFilter.isTrash === 0 ? "ARCHIVE" : "ACTIVATE"} SELECTED
						</Button>
					</Popconfirm>
				</Col>
			)}

			<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
				<Table
					id="tblFacultyLoadList"
					className="ant-table-default ant-table-striped"
					dataSource={
						dataSource && dataSource.data && dataSource.data.data
							? dataSource.data.data
							: []
					}
					rowKey={(record) => record.id}
					pagination={false}
					bordered={false}
					onChange={onChangeTable}
					scroll={{ x: "max-content" }}
					rowSelection={{
						selectedRowKeys,
						onChange: (selectedRowKeys) => {
							setSelectedRowKeys(selectedRowKeys);
						},
					}}
					sticky
				>
					<Table.Column
						title=""
						key="action"
						dataIndex="action"
						align="center"
						width={50}
						render={(text, record) => {
							return (
								<>
									<Button
										type="link"
										className="p-0 w-auto h-auto"
										onClick={() => {
											setToggleModalFormFacultyLoad({
												open: true,
												data: record,
											});
										}}
										name="btn_edit"
									>
										<FontAwesomeIcon icon={faEdit} />
									</Button>
								</>
							);
						}}
					/>
					<Table.Column
						title="Faculty No"
						key="faculty_no"
						dataIndex="faculty_no"
						width={120}
						sorter
					/>
					<Table.Column
						title="Name"
						key="fullname"
						sorter
						dataIndex="fullname"
						width={200}
					/>
					<Table.Column
						title="Schedule"
						key="schedule"
						dataIndex="schedule"
						width={180}
						render={(_, record) => {
							let schedule = "";

							if (record.faculty_load_schedules.length) {
								schedule = record.faculty_load_schedules.map((item, index) => {
									return (
										<div
											key={index}
										>{`${item.time_in} - ${item.time_out} ${item.meridian} ${item.day_schedule}`}</div>
									);
								});
							}

							return schedule;
						}}
					/>

					<Table.Column
						title="Section"
						key="section"
						dataIndex="section"
						width={120}
						sorter
					/>
					<Table.Column
						title="Room"
						key="room_code"
						dataIndex="room_code"
						width={120}
						sorter
					/>
					<Table.Column
						title="Subject"
						key="code"
						dataIndex="code"
						width={130}
						sorter
					/>
					<Table.Column
						title="School Year"
						key="school_year"
						dataIndex="school_year"
						width={150}
						sorter
					/>
					<Table.Column
						title="Semester"
						key="semester"
						dataIndex="semester"
						width={150}
						sorter
					/>
					<Table.Column
						title="Deparment"
						key="deparment"
						dataIndex="deparment"
						width={200}
						sorter
					/>
				</Table>
			</Col>
			<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
				<Flex
					justify="space-between"
					align="center"
					className="tbl-bottom-filter"
				>
					<div />

					<Flex gap={15}>
						<TableShowingEntriesV2 />
						<TablePagination
							tableFilter={tableFilter}
							setTableFilter={setTableFilter}
							total={dataSource?.data.total}
							showLessItems={true}
							showSizeChanger={false}
							tblIdWrapper="tbl_wrapper"
						/>
					</Flex>
				</Flex>
			</Col>

			<ModalFormFacultyLoad
				toggleModalFormFacultyLoad={toggleModalFormFacultyLoad}
				setToggleModalFormFacultyLoad={setToggleModalFormFacultyLoad}
				dataRooms={dataRooms}
			/>
		</Row>
	);
}
